import { AlertService } from './../../shared/services/alert.service';
import { StorageService } from './../../shared/services/storage.service';
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class AclGuardService implements CanActivate {

    indexKickOut = 0;
    kickOutMessages = [];

    constructor(
        private router: Router,
        private alertService: AlertService,
        public storageService: StorageService
    ) {
        this.initKickOutMessage();
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const privilege = route.data.privilege ? route.data.privilege : 'read';
        return route.data.acl ? this.hasAccess(route.data.acl, privilege) : true;
    }


    hasAccess(acl_name: string, droit: string = 'read') {
        let hasAccess = true;
        const aclAccess = this.storageService.getAcl(acl_name);
        if (aclAccess) {
            // Check le droit de lecture & le droit minium requis
            if (!aclAccess['read'] || !aclAccess[droit]) {
                this.kickOut();
            }

            hasAccess = aclAccess['read'] && aclAccess[droit];
        } else {
            this.kickOut();

            hasAccess = false;
        }

        return hasAccess;
    }


    kickOut() {
        this.alertService.error(this.getKickOutMessage());
    }


    getKickOutMessage() {
        if (!this.kickOutMessages[this.indexKickOut]) {
            // On recommence à zéro si plus dans le scope
            this.indexKickOut = 0;
        }

        const msg = this.kickOutMessages[this.indexKickOut];
        this.indexKickOut++;

        return msg;
    }


    initKickOutMessage() {
        this.kickOutMessages.push('Vous ne disposez pas de droits suffisant pour consulter cette page');
    }
}
